import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {TranslocoService} from '@ngneat/transloco';

@Injectable({
    providedIn: 'root',
})
export class IbanService {
    constructor(
        private _translocoService: TranslocoService,
        private httpService: HttpClient) {}

    //transloco
    getCountryCodes(lang:string = 'en'): Observable<any> {
        return this.httpService.get(`assets/iban_${lang}.json`);
    }
}
